/*
  hs-vergleich.js (30.10.2026, Auftrag David): frei wählbare Vergleichsliste.
  Knopf «Vergleichen» auf Produktkarten und Produktseiten (snippets/hs-vergleich-knopf.liquid),
  Leiste unten mit den gewählten Geräten, Vergleichsseite /pages/vergleich (snippets/hs-vergleich-seite.liquid).
  Daten je Gerät: /products/<handle>?view=vergleich (templates/product.vergleich.liquid).
  Regeln: Geräte verschiedener Art landen in getrennten Vergleichen (Reiter), höchstens 4 Geräte je Art.
  Gespeichert wird nur die Liste der Geräte im Browser (localStorage), nichts beim Shop.
*/
(function () {
  if (window.hsVergleich) return;
  var MAX = 4;
  var KEY = 'hsVergleich';
  var SEITE = 'pages/vergleich';
  var root = (window.theme && theme.routes && theme.routes.home) || '/';
  if (root.slice(-1) !== '/') root += '/';
  var speicherNotfall = null;
  var cache = {};

  function lesen() {
    try {
      var s = localStorage.getItem(KEY);
      var d = s ? JSON.parse(s) : null;
      return d && Array.isArray(d.items) ? d.items : [];
    } catch (e) {
      return speicherNotfall || [];
    }
  }
  function schreiben(items) {
    speicherNotfall = items;
    try { localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items })); } catch (e) {}
    melden();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function kurz(t) { return String(t || '').replace(/^ASKO\s+/, ''); }

  function laden(h) {
    if (cache[h]) return cache[h];
    var k = 'hsVglD:' + h;
    try {
      var s = sessionStorage.getItem(k);
      if (s) { var o = JSON.parse(s); if (o && o.zeit > Date.now() - 600000) { cache[h] = Promise.resolve(o.d); return cache[h]; } }
    } catch (e) {}
    cache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '?view=vergleich', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (t) {
        var d = JSON.parse(t);
        try { sessionStorage.setItem(k, JSON.stringify({ zeit: Date.now(), d: d })); } catch (e) {}
        return d;
      })
      .catch(function (e) { delete cache[h]; throw e; });
    return cache[h];
  }

  /* ---------- Hinweis (Toast) ---------- */
  var toastEl, toastTimer;
  function toast(text) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'hs-vgl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    toastEl.classList.add('ist-an');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('ist-an'); }, 4200);
  }

  /* ---------- Liste ändern ---------- */
  function hinzufuegen(h) {
    var items = lesen();
    if (items.some(function (i) { return i.h === h; })) return Promise.resolve(true);
    return laden(h).then(function (d) {
      if (d.sperre) { toast('Abverkaufs- und Ausstellungsgeräte können nicht verglichen werden.'); return false; }
      var items2 = lesen();
      var gleich = items2.filter(function (i) { return i.art === d.art; });
      if (gleich.length >= MAX) {
        toast('Im Vergleich «' + d.an + '» sind schon ' + MAX + ' Geräte. Entfernen Sie zuerst eines.');
        return false;
      }
      items2.push({ h: d.h, art: d.art, an: d.an, t: d.t, b: d.b });
      schreiben(items2);
      var andere = items2.filter(function (i) { return i.art !== d.art; }).length;
      toast(gleich.length === 0 && andere > 0
        ? kurz(d.t) + ' ist im Vergleich. Geräte gleicher Art stehen im eigenen Reiter, unter «Alle zusammen» sehen Sie alle Geräte nebeneinander.'
        : kurz(d.t) + ' ist im Vergleich (' + (gleich.length + 1) + ' von ' + MAX + ').');
      return true;
    }).catch(function () {
      toast('Das Gerät konnte nicht geladen werden. Bitte versuchen Sie es nochmals.');
      return false;
    });
  }
  function entfernen(h) {
    schreiben(lesen().filter(function (i) { return i.h !== h; }));
  }

  /* ---------- Knöpfe ---------- */
  /* Auf der Produktkarte wird der Knopf im Produktlink ausgegeben (snippets/hs-garantie-haefeli.liquid).
     Ein Knopf in einem Link ist ungültig, darum kommt er hier direkt hinter den Link. */
  function versetzen() {
    /* 30.10.2026: Auf der Karte liegt der Produktlink über dem Knopf. Knopf direkt hinter den Link setzen
       und darüber legen, sonst kommt der Klick nicht an. */
    var els = document.querySelectorAll('.hs-vgl-knopf');
    for (var n = 0; n < els.length; n++) {
      var k = els[n];
      var a = k.closest('a');
      if (a && a.parentNode) a.parentNode.insertBefore(k, a.nextSibling);
      var karte = k.closest('.grid-product');
      var link = karte && karte.querySelector('.grid-product__link');
      if (link && link.parentNode && k.previousElementSibling !== link && !link.contains(k)) link.parentNode.insertBefore(k, link.nextSibling);
      if (k.style.position !== 'relative') { k.style.position = 'relative'; k.style.zIndex = '3'; }
    }
  }
  function knoepfe() {
    versetzen();
    var set = {};
    lesen().forEach(function (i) { set[i.h] = true; });
    var els = document.querySelectorAll('input[data-hs-vgl]');
    for (var n = 0; n < els.length; n++) {
      var el = els[n];
      var an = !!set[el.getAttribute('data-hs-vgl')];
      el.checked = an;
      var lab = el.closest('.hs-vgl-knopf');
      if (lab) {
        lab.classList.toggle('ist-an', an);
        var tx = lab.querySelector('[data-hs-vgl-text]');
        var soll = an ? 'Im Vergleich' : 'Vergleichen';
        if (tx && !lab.classList.contains('ist-laden') && tx.textContent !== soll) tx.textContent = soll;
      }
    }
  }
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('input[data-hs-vgl]')) return;
    var h = el.getAttribute('data-hs-vgl');
    var lab = el.closest('.hs-vgl-knopf');
    if (el.checked) {
      if (lab) { lab.classList.add('ist-laden'); var tx = lab.querySelector('[data-hs-vgl-text]'); if (tx) tx.textContent = 'Wird hinzugefügt'; }
      hinzufuegen(h).then(function () { if (lab) lab.classList.remove('ist-laden'); knoepfe(); });
    } else {
      entfernen(h);
    }
  });
  /* Falls ein Knopf noch im Link steckt: Klick nicht als Link werten */
  document.addEventListener('click', function (e) {
    var lab = e.target && e.target.closest && e.target.closest('.hs-vgl-knopf');
    if (!lab || !lab.closest('a')) return;
    e.preventDefault();
    var inp = lab.querySelector('input[data-hs-vgl]');
    if (inp && e.target !== inp) { inp.checked = !inp.checked; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    else if (inp) { setTimeout(function () { inp.dispatchEvent(new Event('change', { bubbles: true })); }, 0); }
    versetzen();
  }, true);

  /* ---------- Leiste unten ---------- */
  var leiste;
  function aufSeite() { return location.pathname.replace(/\/$/, '').slice(-SEITE.length) === SEITE; }
  function leisteZeichnen() {
    var items = lesen();
    if (aufSeite()) { if (leiste) leiste.hidden = true; return; }
    if (!leiste) {
      leiste = document.createElement('div');
      leiste.className = 'hs-vgl-leiste';
      leiste.setAttribute('aria-label', 'Gerätevergleich');
      leiste.setAttribute('role', 'region');
      document.body.appendChild(leiste);
      leiste.addEventListener('click', function (e) {
        var x = e.target.closest('[data-hs-vgl-weg]');
        if (x) { e.preventDefault(); entfernen(x.getAttribute('data-hs-vgl-weg')); }
        var auf = e.target.closest('[data-hs-vgl-auf]');
        if (auf) { e.preventDefault(); leiste.classList.toggle('ist-offen'); }
      });
    }
    if (!items.length) { leiste.hidden = true; document.body.classList.remove('hs-vgl-leiste-an'); return; }
    var arten = {};
    items.forEach(function (i) { arten[i.art] = (arten[i.art] || 0) + 1; });
    var nArten = Object.keys(arten).length;
    var chips = items.map(function (i) {
      return '<li class="hs-vgl-chip">' +
        (i.b ? '<img src="' + esc(i.b) + '" alt="" width="40" height="40" loading="lazy">' : '') +
        '<span class="hs-vgl-chip-t">' + esc(kurz(i.t)) + '</span>' +
        '<a href="#" class="hs-vgl-chip-x" data-hs-vgl-weg="' + esc(i.h) + '" aria-label="' + esc(kurz(i.t)) + ' aus dem Vergleich entfernen">×</a></li>';
    }).join('');
    leiste.innerHTML =
      '<div class="hs-vgl-leiste-in">' +
        '<a href="#" class="hs-vgl-leiste-zahl" data-hs-vgl-auf aria-label="Gewählte Geräte anzeigen">' +
          '<strong>' + items.length + '</strong> ' + (items.length === 1 ? 'Gerät' : 'Geräte') + ' im Vergleich' +
          (nArten > 1 ? '<span class="hs-vgl-leiste-arten">' + nArten + ' Vergleiche</span>' : '') +
        '</a>' +
        '<ul class="hs-vgl-chips">' + chips + '</ul>' +
        '<a class="hs-vgl-los" href="' + root + SEITE + '">Jetzt vergleichen</a>' +
      '</div>';
    leiste.hidden = false;
    document.body.classList.add('hs-vgl-leiste-an');
  }

  function melden() { knoepfe(); leisteZeichnen(); if (seite) seiteZeichnen(); }

  /* ---------- Vergleichsseite ---------- */
  var seite = null, aktiv = null, nurDiff = false, geteilt = null, formAuto = true;

  function teile(z) {
    return String(z || '').split('##').filter(Boolean).map(function (e) {
      var i = e.lastIndexOf('|');
      return { w: e.slice(0, i).trim(), l: e.slice(i + 1).trim() };
    });
  }
  /* Gleiche Merkmale verschiedener Marken unter einem Namen (30.10.2026) */
  function normChip(c) {
    if (/WLAN|ConnectLife|Home Connect/i.test(c)) return 'WLAN-fähig';
    if (/^AutoDose$/i.test(c)) return 'Automatische Dosierung';
    if (/NoFrost/i.test(c)) return 'NoFrost';
    return c;
  }
  function zeilen(geraete) {
    var rows = [];
    function zeile(label, werte, opt) {
      if (!werte.some(function (w) { return w !== '' && w != null; })) return;
      var vgl = (opt && opt.vgl) || werte;
      var diff = vgl.some(function (w) { return String(w) !== String(vgl[0]); });
      rows.push({ l: label, w: werte, diff: diff, art: (opt && opt.art) || 'text', html: opt && opt.html });
    }
    zeile('Preis', geraete.map(function (g) {
      return '<strong>' + esc(g.pf) + '</strong>' + (g.uvp ? '<span class="hs-vgl-uvp">UVP ' + esc(g.uvp) + '</span>' : '');
    }), { html: true, vgl: geraete.map(function (g) { return g.p; }) });
    var labels = [];
    var werte = geraete.map(function (g) {
      var o = {};
      teile(g.z).forEach(function (p) { o[p.l] = p.w; if (labels.indexOf(p.l) < 0) labels.push(p.l); });
      return o;
    });
    labels.forEach(function (l) { zeile(l, werte.map(function (o) { return o[l] || ''; })); });
    zeile('Energieeffizienz', geraete.map(function (g) { return g.e; }));
    zeile('Bedienung', geraete.map(function (g) { return g.bed; }));
    zeile('Serie', geraete.map(function (g) { return g.serie; }));
    zeile('Einbauart', geraete.map(function (g) { return g.einbau; }));
    zeile('Montage', geraete.map(function (g) { return g.montage; }));
    zeile('Masse (B × H × T)', geraete.map(function (g) { return g.masse; }));
    zeile('Nischenhöhe', geraete.map(function (g) { return g.nische; }));
    zeile('Anschluss', geraete.map(function (g) { return g.ans; }));
    zeile('Anschlussleistung', geraete.map(function (g) { return g.kw ? String(Math.round(parseFloat(g.kw) * 100) / 100).replace('.', ',') + ' kW' : ''; }));
    zeile('Absicherung', geraete.map(function (g) { return g.abs; }));
    zeile('Garantie', geraete.map(function (g) { return g.gar; }));
    zeile('Verfügbarkeit', geraete.map(function (g) { return g.hinweis || g.lager; }));
    var chips = [];
    var sets = geraete.map(function (g) {
      var a = String(g.a || '').split(';').map(function (s) { return normChip(s.trim()); }).filter(Boolean);
      a.forEach(function (c) { if (chips.indexOf(c) < 0) chips.push(c); });
      return a;
    });
    if (chips.length) {
      rows.push({ kopf: 'Ausstattung' });
      chips.forEach(function (c) {
        var w = sets.map(function (s) { return s.indexOf(c) >= 0 ? 1 : 0; });
        rows.push({ l: c, w: w, diff: w.some(function (x) { return x !== w[0]; }), art: 'check' });
      });
    }
    return rows;
  }

  function tabelle(geraete, eigen) {
    var rows = zeilen(geraete);
    var nDiff = rows.filter(function (r) { return r.diff; }).length;
    var h = '<div class="hs-vgl-scroll"><table class="hs-vgl-tab' + (nurDiff ? ' nur-diff' : '') + '" style="--hs-vgl-n:' + geraete.length + '">';
    h += '<thead><tr><th class="hs-vgl-ecke" scope="col"><span class="hs-vgl-diffzahl">' +
      (geraete.length > 1 ? (nDiff === 1 ? '1 Unterschied' : nDiff + ' Unterschiede') : '') + '</span></th>';
    geraete.forEach(function (g) {
      h += '<th scope="col" class="hs-vgl-geraet">' +
        (eigen ? '<button type="button" class="hs-vgl-weg" data-hs-vgl-weg="' + esc(g.h) + '" aria-label="' + esc(kurz(g.t)) + ' entfernen">×</button>' : '') +
        '<a href="' + esc(g.u) + '" class="hs-vgl-bild">' + (g.b ? '<img src="' + esc(g.b) + '" alt="' + esc(g.t) + '" loading="lazy">' : '') + '</a>' +
        '<span class="hs-vgl-marke">' + esc(g.m) + '</span>' +
        '<a href="' + esc(g.u) + '" class="hs-vgl-name">' + esc(kurz(g.t)) + '</a>' +
        '</th>';
    });
    h += '</tr></thead><tbody>';
    rows.forEach(function (r) {
      if (r.kopf) { h += '<tr class="hs-vgl-zwkopf"><th scope="rowgroup" colspan="' + (geraete.length + 1) + '">' + esc(r.kopf) + '</th></tr>'; return; }
      h += '<tr class="' + (r.diff ? 'ist-diff' : 'ist-gleich') + '"><th scope="row">' + esc(r.l) + '</th>';
      r.w.forEach(function (w) {
        var inhalt;
        if (r.art === 'check') inhalt = w ? '<span class="hs-vgl-ja" aria-label="ja">✓</span>' : '<span class="hs-vgl-nein" aria-label="nein">–</span>';
        else inhalt = r.html ? w : (w === '' ? '<span class="hs-vgl-nein">–</span>' : esc(w));
        h += '<td>' + inhalt + '</td>';
      });
      h += '</tr>';
    });
    h += '<tr class="hs-vgl-fuss"><th scope="row"></th>';
    geraete.forEach(function (g) { h += '<td><a class="hs-vgl-zum" href="' + esc(g.u) + '">Zum Gerät</a></td>'; });
    h += '</tr></tbody></table></div>';
    return h;
  }

  function formular(geraete) {
    var t = document.getElementById('kfText');
    var form = t && t.form;
    if (!form) return;
    var liste = geraete.map(function (g) { return '• ' + g.t + ' (' + g.pf + ')\n  ' + location.origin + g.u; }).join('\n');
    var hid = form.querySelector('input[name="contact[Vergleich]"]');
    if (!hid) { hid = document.createElement('input'); hid.type = 'hidden'; hid.name = 'contact[Vergleich]'; form.appendChild(hid); }
    hid.value = geraete.map(function (g) { return g.t; }).join(', ');
    if (!t.dataset.hsVglBind) {
      t.dataset.hsVglBind = '1';
      t.addEventListener('input', function () { formAuto = false; });
    }
    if (formAuto && (t.value === '' || t.dataset.hsVglAuto === '1')) {
      t.value = geraete.length
        ? 'Guten Tag\n\nIch vergleiche folgende Geräte:\n' + liste + '\n\nMeine Frage dazu:\n'
        : '';
      t.dataset.hsVglAuto = '1';
    }
  }

  function seiteZeichnen() {
    var ziel = seite.querySelector('[data-hs-vgl-inhalt]');
    var eigen = !geteilt;
    var handles = eigen ? lesen().map(function (i) { return i.h; }) : geteilt;
    if (!handles.length) {
      ziel.innerHTML = '<div class="hs-vgl-leer"><p><strong>Noch keine Geräte im Vergleich.</strong></p>' +
        '<p>Wählen Sie in den Übersichten oder auf der Produktseite bei einem Gerät «Vergleichen».</p>' +
        '<a class="hs-vgl-btn" href="' + root + 'collections/all">Geräte ansehen</a></div>';
      formular([]);
      return;
    }
    Promise.all(handles.map(function (h) { return laden(h).catch(function () { return null; }); })).then(function (liste) {
      var geraete = liste.filter(function (d) { return d && !d.sperre; });
      var gruppen = [], idx = {};
      geraete.forEach(function (g) {
        if (!(g.art in idx)) { idx[g.art] = gruppen.length; gruppen.push({ art: g.art, an: g.an, g: [] }); }
        gruppen[idx[g.art]].g.push(g);
      });
      if (!gruppen.length) { ziel.innerHTML = '<div class="hs-vgl-leer"><p>Die Geräte dieses Vergleichs sind nicht mehr verfügbar.</p></div>'; return; }
      if (!aktiv || (aktiv !== '__alle' && !(aktiv in idx))) {
        var letzt = eigen ? lesen().slice(-1)[0] : null;
        aktiv = letzt && (letzt.art in idx) ? letzt.art : gruppen[0].art;
      }
      /* 30.10.2026 (Wunsch David): zusätzlich alle Geräte querbeet nebeneinander, Reiter «Alle zusammen» */
      var ALLE = '__alle';
      if (aktiv !== ALLE && !(aktiv in idx)) aktiv = gruppen[0].art;
      var gr = aktiv === ALLE ? { art: ALLE, an: 'Alle Geräte zusammen', g: geraete } : gruppen[idx[aktiv]];
      var h = '';
      if (!eigen) {
        h += '<div class="hs-vgl-geteilt"><span>Dieser Vergleich wurde mit Ihnen geteilt.</span>' +
          '<button type="button" class="hs-vgl-btn" data-hs-vgl-uebernehmen>In meine Liste übernehmen</button></div>';
      }
      if (gruppen.length > 1) {
        h += '<div class="hs-vgl-reiter" role="tablist" aria-label="Vergleiche nach Geräteart">';
        h += '<button type="button" role="tab" aria-selected="' + (aktiv === ALLE) + '" class="hs-vgl-reiter-k' + (aktiv === ALLE ? ' ist-an' : '') + '" data-hs-vgl-art="' + ALLE + '">Alle zusammen <span>' + geraete.length + '</span></button>';
        gruppen.forEach(function (x) {
          var an = x.art === aktiv;
          h += '<button type="button" role="tab" aria-selected="' + an + '" class="hs-vgl-reiter-k' + (an ? ' ist-an' : '') + '" data-hs-vgl-art="' + esc(x.art) + '">' +
            esc(x.an) + ' <span>' + x.g.length + '</span></button>';
        });
        h += '</div>';
      }
      h += '<div class="hs-vgl-werkzeug">' +
        '<label class="hs-vgl-schalter"><input type="checkbox" data-hs-vgl-diff' + (nurDiff ? ' checked' : '') + '> Nur Unterschiede zeigen</label>' +
        '<span class="hs-vgl-werkzeug-r">' +
        '<button type="button" class="hs-vgl-link" data-hs-vgl-teilen>Link teilen</button>' +
        '<button type="button" class="hs-vgl-link" data-hs-vgl-druck>Drucken</button>' +
        (eigen ? '<button type="button" class="hs-vgl-link" data-hs-vgl-leeren>Diesen Vergleich leeren</button>' : '') +
        '</span></div>';
      h += '<h2 class="hs-vgl-art">' + esc(gr.an) + '</h2>';
      if (aktiv === ALLE) {
        h += '<p class="hs-vgl-tipp">Hier stehen alle gewählten Geräte nebeneinander, auch verschiedene Gerätearten. Werte, die ein Gerät nicht hat, sind mit – markiert.</p>';
      } else if (gr.g.length < 2) {
        h += '<p class="hs-vgl-tipp">Wählen Sie ein weiteres Gerät dieser Art, dann stehen die Werte direkt nebeneinander. ' +
          '<a href="' + root + 'collections/all">Geräte ansehen</a></p>';
      } else if (eigen && gr.g.length < MAX) {
        h += '<p class="hs-vgl-tipp">Sie können noch ' + (MAX - gr.g.length) + ' ' + (MAX - gr.g.length === 1 ? 'Gerät' : 'Geräte') + ' dieser Art hinzufügen.</p>';
      }
      h += tabelle(gr.g, eigen);
      h += '<p class="hs-vgl-quelle">Werte aus den Produktdaten der Hersteller. Preise inkl. MwSt.</p>';
      ziel.innerHTML = h;
      formular(gr.g);
    });
  }

  function seiteStart(el) {
    seite = el;
    try {
      var g = new URLSearchParams(location.search).get('g');
      if (g) geteilt = g.split(',').map(function (s) { return s.trim(); }).filter(function (s) { return /^[a-z0-9-]+$/i.test(s); }).slice(0, 12);
      if (geteilt && !geteilt.length) geteilt = null;
    } catch (e) {}
    seite.addEventListener('click', function (e) {
      var t = e.target;
      var a = t.closest('[data-hs-vgl-art]');
      if (a) { aktiv = a.getAttribute('data-hs-vgl-art'); formAuto = true; seiteZeichnen(); return; }
      var w = t.closest('[data-hs-vgl-weg]');
      if (w) { entfernen(w.getAttribute('data-hs-vgl-weg')); return; }
      if (t.closest('[data-hs-vgl-druck]')) { window.print(); return; }
      if (t.closest('[data-hs-vgl-leeren]')) {
        var rest = aktiv === '__alle' ? [] : lesen().filter(function (i) { return i.art !== aktiv; });
        aktiv = null; schreiben(rest); return;
      }
      if (t.closest('[data-hs-vgl-uebernehmen]')) {
        var hs = geteilt; geteilt = null;
        history.replaceState(null, '', location.pathname);
        hs.reduce(function (p, h) { return p.then(function () { return hinzufuegen(h); }); }, Promise.resolve()).then(melden);
        return;
      }
      if (t.closest('[data-hs-vgl-teilen]')) {
        var tab = seite.querySelectorAll('.hs-vgl-geraet .hs-vgl-name');
        var hsAktiv = (geteilt || lesen().filter(function (i) { return aktiv === '__alle' || i.art === aktiv; }).map(function (i) { return i.h; }));
        if (geteilt) {
          hsAktiv = [];
          for (var n = 0; n < tab.length; n++) { var m = tab[n].getAttribute('href').match(/products\/([^/?#]+)/); if (m) hsAktiv.push(m[1]); }
        }
        var url = location.origin + location.pathname + '?g=' + hsAktiv.join(',');
        if (navigator.share && window.matchMedia('(max-width: 768px)').matches) {
          navigator.share({ title: 'Gerätevergleich', url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { toast('Link kopiert. Sie können ihn jetzt einfügen und versenden.'); },
            function () { window.prompt('Link zum Vergleich', url); });
        } else { window.prompt('Link zum Vergleich', url); }
      }
    });
    seite.addEventListener('change', function (e) {
      if (e.target.matches('[data-hs-vgl-diff]')) {
        nurDiff = e.target.checked;
        var tb = seite.querySelector('.hs-vgl-tab');
        if (tb) tb.classList.toggle('nur-diff', nurDiff);
      }
    });
    seiteZeichnen();
  }

  /* ---------- Start ---------- */
  function start() {
    var el = document.querySelector('[data-hs-vgl-seite]');
    if (el) seiteStart(el);
    knoepfe();
    leisteZeichnen();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(knoepfe, 120); })
      .observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === KEY) melden(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) melden(); });
  }
  window.hsVergleich = { lesen: lesen, hinzufuegen: hinzufuegen, entfernen: entfernen };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
